<!--
 * @Description  : 学校参与情况-提供课后服务学校明细表, 服务时间(5+2)达标学校明细表, 课程安排(1+X)达标学校
 * @Author       : chenJunHui
 * @LastEditors: chenJunHui
 * @Date         : 2022-09-06 14:02:57
 * @LastEditTime: 2022-11-14 14:49:38
 * @FilePath     : \after_class_service\src\pages\cloudMap\proupTable\schoolPart.vue
-->
<template>
  <div class="indexs">
    <div class="tabs" v-if="org_type == 2 || isSchool">
      <p :class="{ active: !tabActice }" @click="tabActice = false">
        行政班
      </p>
      <p :class="{ active: tabActice }" @click="tabActice = true">
        教学班
      </p>
    </div>
    <div class="table">
      <!-- 区级表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        :border="true"
        :current-page.sync="currentPage"
        :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }"
        v-show="org_type != 2"
      >
        <el-table-column prop="orga_name" label="学校名称" align="center">
        </el-table-column>
        <el-table-column
          prop="tea_attendance_per"
          label="教师出勤率"
          align="center"
          :formatter="tofixed"
        >
        </el-table-column>
        <el-table-column
          prop="stu_attendance_per"
          label="学生出勤率"
          align="center"
          :formatter="tofixed"
        >
        </el-table-column>
      </el-table>
      <!-- 校级表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        :border="true"
        :current-page.sync="currentPage"
        :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }"
        v-show="org_type == 2 || isSchool"
      >
        <el-table-column
          :prop="
            !isSchool
              ? 'orga_name'
              : tabActice
              ? 'teaching_class_name'
              : 'class_name'
          "
          label="行政班"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="orga_name" label="所属校区" align="center">
        </el-table-column>
        <el-table-column
          prop="stu_attendance_per"
          label="学生出勤率"
          align="center"
          :formatter="tofixed"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        style="margintop: 20px; textalign: center"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import cloudMapApi from "@/api/cloudMapApi.js";
import { mapMutations, mapState } from "vuex";
export default {
  props: ["selectParmam"],
  components: {},
  computed: {
    ...mapState(["isSchool"]),
  },
  data() {
    return {
      selectParmams: {},
      org_type: sessionStorage.org_type, // 1:教育局, 2:学校, 8:机构
      tabActice: 0,
      tableData: [],
      total: 0,
      currentPage: 1,
      loading: false,
    };
  },
  created() {
    console.log(this.org_type,this.isSchool);
  },
  watch: {
    selectParmam(n, o) {
      console.log(this.selectParmam, this.isSchool, "this.selectParmams");
      this.selectParmams = n;
      this.getData();
    },
    tabActice(n, o) {
      this.getData();
    },
  },
  mounted() {
    console.log(this.selectParmam, "this.selectParmams");
    this.selectParmams = this.selectParmam;
    this.getData();
  },
  methods: {
    tofixed(row, colum, cellValue) {
      if (cellValue != null) {
        return (cellValue * 100).toFixed(2) + "%";
      }
    },
    handleSizeChange(val) {
      this.selectParmams.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.selectParmams.pagenum = val;
      this.getData();
    },
    ...mapMutations(["updateLoadingStatus"]),
    async getData() {
      this.pageNum_1 = 1;
      if (this.org_type == "1" && !this.isSchool) {
        this.selectParmams.topic = "校";
      } else {
        this.selectParmams.topic = !this.tabActice ? "行政班" : "教学班";
      }
      this.getList_1();
    },
    async getList_1() {
      this.loading = true;
      try {
        let res = await cloudMapApi.getTeacherAttendance(this.selectParmams);
        this.tableData = res.data.rows;
        this.total = res.data.total;
        // let api = '';
        // if (this.orgType == '1' && !this.isSchool) {
        //   // 教育局
        //   api = 'afterClassDetail';
        //   params.prd_id = this.activeTab;
        //   if (this.type === 'one') {
        //     params.topic = '1'; // 提供服务
        //     params.is_std = this.active_1 === '已提供课后服务' ? '1' : '0';
        //   } else if (this.type === 'two') {
        //     params.topic = '2'; // 课程时间
        //     params.is_std = this.active_1 === '已达标' ? '1' : '0';
        //   } else {
        //     params.topic = '3'; // 课程时间
        //     params.is_std = this.active_1 === '已达标' ? '1' : '0';
        //   }
        // } else {
        //   // 学校
        //   api = 'afterClassDetailSchool';
        //   params.grade_id = this.activeTab;
        //   if (this.type === 'two') {
        //     params.topic = '1'; // 课程时间
        //     params.is_std = this.active_1 === '已达标' ? '1' : '0';
        //   } else {
        //     params.topic = '2'; // 课程时间
        //     params.is_std = this.active_1 === '已达标' ? '1' : '0';
        //   }
        // }
        // let res = await cloudMapApi[api](params);
        // if (res.code == '0') {
        //   this.dataList_1 = [...this.dataList_1, ...res.data.rows];
        //   this.total_1 = res.data.total || 0;
        //   this.noMore_1 = this.pageNum_1 * this.pageSize_1 >= this.total_1;
        // }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        // this.updateLoadingStatus({ show: false });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.indexs {
  .no_data {
    text-align: center;
    margin: 20px;
  }
  .header {
    width: 100%;
    height: 50px;
    background: #ffffff;
    font-size: 18px;
    line-height: 25px;
    font-weight: bold;
    color: #000000;
    padding: 14px 15px 11px;
  }
  .tabs {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 14px 15px 11px;
    overflow-x: auto;
    flex-wrap: nowrap;
    flex-shrink: 0;

    .tab {
      padding: 5px 15px;
      background: #eff7ff;
      border: 1px solid #beddff;
      border-radius: 24px;
      font-size: 14px;
      line-height: 20px;
      color: #0067da;
      margin-right: 10px;
      flex: 0 0 auto;
    }
  }
}
</style>
